import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\TaskDossier\FetchTaskDossierForDashboardController::__invoke
* @see app/Http/Controllers/TaskDossier/FetchTaskDossierForDashboardController.php
* @route '/api/fetch-dossier-tasks'
*/
const FetchTaskDossierForDashboardController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: FetchTaskDossierForDashboardController.url(options),
    method: 'post',
})

FetchTaskDossierForDashboardController.definition = {
    methods: ["post"],
    url: '/api/fetch-dossier-tasks',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\TaskDossier\FetchTaskDossierForDashboardController::__invoke
* @see app/Http/Controllers/TaskDossier/FetchTaskDossierForDashboardController.php
* @route '/api/fetch-dossier-tasks'
*/
FetchTaskDossierForDashboardController.url = (options?: RouteQueryOptions) => {
    return FetchTaskDossierForDashboardController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\TaskDossier\FetchTaskDossierForDashboardController::__invoke
* @see app/Http/Controllers/TaskDossier/FetchTaskDossierForDashboardController.php
* @route '/api/fetch-dossier-tasks'
*/
FetchTaskDossierForDashboardController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: FetchTaskDossierForDashboardController.url(options),
    method: 'post',
})

export default FetchTaskDossierForDashboardController